import { useFormik } from "formik";
import React from "react";
import { useAppDispatch, useAppSelector } from "../../../State/Store";
import { Button, TextField } from "@mui/material";
import { fetchUserProfile, LoginOtpRequest, sendLoginSignupOtp, signIn, signUp } from "../../../State/AuthSlice";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
type Props = {
  setLocalError: React.Dispatch<React.SetStateAction<string | null>>;
  setSuccessMessage: React.Dispatch<React.SetStateAction<string | null>>;
};
const validationSchema = Yup.object({
  fullName: Yup.string()
    .required("Full name is required")
    .matches(
      /^[a-zA-Z\s]+$/,
      "Full name should contain only letters and spaces"
    ),
  email: Yup.string()
    .email("Invalid email format")
    .required("Email is required"),
  mobile: Yup.string()
    .required("Mobile number is required")
    .matches(/^[0-9]{10}$/, "Mobile number must be exactly 10 digits"),
  otp: Yup.string()
    .required("OTP is required")
    .matches(/^[0-9]{6}$/, "OTP must be a 6-digit number"),
});
export const RegisterForm: React.FC<Props> = ({
  setLocalError,
  setSuccessMessage,
}) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { auth } = useAppSelector((store) => store);
  const formik = useFormik({
    initialValues: {
      email: "",
      otp: "",
      fullName: "",
      mobile: "",
    },
    validationSchema,
    onSubmit: async (values) => {
    
      setSuccessMessage(null);
      try {
        setLocalError(null);
       await dispatch(signUp(values)).unwrap();
      
        setSuccessMessage("SignUp successfully redirect to Homepage");
        setTimeout(async() => {
          await dispatch(fetchUserProfile()).unwrap();
          navigate("/"); // Navigate after 1 second
        }, 1500); // 1000ms delay
      } catch (error: any) {
        setSuccessMessage(null);
        setLocalError(error);
      }
    },
  });
  const handleSentOtp = async () => {
   
    try {
      setLocalError(null);
      
      let values:LoginOtpRequest = {
        email:formik.values.email,
        role :"ROLE_CUSTOMER",
        isSignup:true
      };
   
      // The issue here is that the error is not caught completely in your try-catch and propagates as an so need to async await
      await dispatch(
        sendLoginSignupOtp(values)
      ).unwrap();
      setSuccessMessage("Otp Sent Successfully");
    } catch (error: any) {
    

      setLocalError(error);
    }
  };
 
  return (
    <div>
      <h1 className="text-center font-bold text-xl text-primary pb-8">
        Register
      </h1>
      <form>
        <div className="space-y-5">
          <TextField
            fullWidth
            name="email"
            label="Email"
            value={formik.values.email}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.email && Boolean(formik.errors.email)}
            helperText={formik.touched.email && formik.errors.email}
          />

          {auth.otpSent && (
            <div className="space-y-5">
              <div className="space-y-2">
                <p className="font-medium text-sm opacity-60">
                  Enter OTP Sent to Your Email
                </p>
                <TextField
                  fullWidth
                  name="otp"
                  label="Otp"
                  value={formik.values.otp}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.otp && Boolean(formik.errors.otp)}
                  helperText={formik.touched.otp && formik.errors.otp}
                />
                <TextField
                  fullWidth
                  name="fullName"
                  label="Full Name"
                  value={formik.values.fullName}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={
                    formik.touched.fullName && Boolean(formik.errors.fullName)
                  }
                  helperText={formik.touched.fullName && formik.errors.fullName}
                />
                <TextField
                  fullWidth
                  name="mobile"
                  label="Mobile"
                  value={formik.values.mobile}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.mobile && Boolean(formik.errors.mobile)}
                  helperText={formik.touched.mobile && formik.errors.mobile}
                />
              </div>
            </div>
          )}
          {!auth.otpSent ? (
            <Button
              onClick={() => { handleSentOtp() }}
              fullWidth
              variant="contained"
              sx={{ py: "11px" }}
            >
              Sent otp
            </Button>
          ) : (
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ py: "11px" }}
              onClick={(e) => {
                e.preventDefault();
                formik.handleSubmit();
              }}
            >
              Register
            </Button>
          )}
        </div>
      </form>
    </div>
  );
};
